module.exports = __webpack_public_path__ + "img/corpImg.3cdc35ec.png";